function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
import ConstantsMetaDataEdit from './ConstantsMetaDataEdit.react';
var ConstantsTemplate = function ConstantsTemplate(_ref) {
  var title = _ref.title,
    constants = _ref.constants,
    addModalAction = _ref.addModalAction;
  var tableData = {
    columns: {
      'group': 'Group',
      'type': 'Type',
      'key': 'Key',
      'value': 'Value',
      'description': 'Description'
    },
    data: constants
  };
  var addModal = function addModal(_ref2) {
    var _ref2$constant = _ref2.constant,
      constant = _ref2$constant === void 0 ? null : _ref2$constant;
    addModalAction({
      component: /*#__PURE__*/React.createElement(ConstantsMetaDataEdit, {
        constant: constant,
        constants: constants
      })
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: title,
    button: {
      label: 'Add',
      type: 'add',
      onClick: function onClick() {
        return addModal({});
      }
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    actions: {
      edit: {
        onEdit: function onEdit(constant) {
          return addModal({
            constant: constant
          });
        }
      }
    }
  })));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(ConstantsTemplate);